export var ADD_QUICKBET_RATE = 'ADD_QUICKBET_RATE';
export var OPEN_QUICKBET_MODAL = 'OPEN_QUICKBET_MODAL';
export var CLOSE_QUICKBET_MODAL = 'CLOSE_QUICKBET_MODAL';
export var CHANGE_QUICKBET_AMOUNT = 'CHANGE_QUICKBET_AMOUNT';
export var ACCEPT_QUICKBET_FACTOR_CHANGE = 'ACCEPT_QUICKBET_FACTOR_CHANGE';



// WEBPACK FOOTER //
// ./src/actions/coupon/quickbet.js